import { render, staticRenderFns } from "./LaborInput.vue?vue&type=template&id=cdcb17f6&scoped=true&"
import script from "./LaborInput.vue?vue&type=script&lang=js&"
export * from "./LaborInput.vue?vue&type=script&lang=js&"
import style0 from "./LaborInput.vue?vue&type=style&index=0&id=cdcb17f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcb17f6",
  null
  
)

export default component.exports